"use client";

// Catches errors in the root layout itself -- the true "500" fallback. Per Next's own docs,
// global-error renders its own document and does NOT get globals.css or next/font, so this is
// deliberately plain, self-contained inline styles rather than Tailwind classes that might not
// apply here. Same reasoning rules out i18n/LocaleProvider here too -- it lives inside the root
// layout this file replaces, so this stays hardcoded English, same as the exception already made
// for styling.
export default function GlobalError({
  retry,
}: {
  error: Error & { digest?: string };
  retry: () => void;
}) {
  return (
    <html lang="en">
      <body style={{ fontFamily: "system-ui, sans-serif", background: "#fbf7f2", color: "#241c16" }}>
        <main style={{ maxWidth: 420, margin: "0 auto", padding: "6rem 1.5rem", textAlign: "center" }}>
          <h1 style={{ fontSize: "2rem", fontStyle: "italic" }}>Something went wrong</h1>
          <p style={{ marginTop: "1rem", opacity: 0.8 }}>
            Sorry about that. Please try again.
          </p>
          <button
            onClick={retry}
            style={{
              marginTop: "2rem",
              borderRadius: "999px",
              background: "#c1502e",
              color: "#fdf1ea",
              padding: "0.75rem 1.5rem",
              fontWeight: 600,
              border: "none",
              cursor: "pointer",
            }}
          >
            Try again
          </button>
        </main>
      </body>
    </html>
  );
}
